import React from "react";
import {
  Box,
  Card,
  CardContent,
  Chip,
  Grid,
  Tooltip,
  Typography,
} from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { Link } from "react-router-dom";
import NumberFormat from "react-number-format";
import { client } from "../../../service/ApolloClient/ApolloClient";
import { QUERY_CHEQUES } from "../../../service/ApolloClient/ApolloQueries";
import MaterialTableRtl from "../../UI/MaterialTableRtl/MaterialTableRtl";
import { numberFormatter } from "../../../utility/Number/numberFormatter";

class ChequeSummaryTables extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: "all",
    };
  }

  getColumns = () => {
    return [
      {
        title: "#",
        field: "id",
        render: (rowData) => {
          return (
            <Link to={`/cheque/edit/${rowData.id}`}>
              {rowData.guarantor_id === 79 ? (
                <Tooltip title={"ضمانت فریدونی"}>
                  <Chip
                    color={"secondary"}
                    variant="outlined"
                    label={rowData.id}
                  />
                </Tooltip>
              ) : (
                rowData.id
              )}
            </Link>
          );
        },
      },
      {
        title: "مبلغ",
        field: "amount",
        render: (rowData) => (
          <NumberFormat
            value={rowData.amount}
            thousandSeparator={true}
            displayType={"text"}
          />
        ),
        pdfRender: (rowData) => numberFormatter(rowData.amount),
      },

      {
        title: "سررسید",
        field: "due_date_fa",
        render: (rowData) => rowData.due_date_fa,
      },

      { title: "شماره چک", field: "cheque_id" },

      { title: "شماره صیاد", field: "icis" },

      {
        title: "دهنده",
        field: "giver_user_fullname",
        render: (rowData) =>
          rowData.giver_user_id ? (
            <a href={`/person/edit/${rowData.giver_user_id}`}>
              {rowData.giver_user_fullname}
            </a>
          ) : (
            "مشخص نشده"
          ),
      },
      {
        title: "گیرنده",
        field: "reciver_user_fullname",
        render: (rowData) => {
          const name = rowData.reciver_user_fullname;
          if (!name) return "مشخص نشده";
          const type = rowData.recieverable_type;
          const id = rowData.recieverable_id;
          if (type === "bank") {
            return <a href={`/bank-account/edit/${id}`}>{name}</a>;
          }
          if (type === "legal_entity") {
            return <a href={`/legal-entity/edit/${id}`}>{name}</a>;
          }
          return <a href={`/person/edit/${rowData.reciver_user_id}`}>{name}</a>;
        },
      },
      {
        title: "مالک",
        field: "first_party_fullname",
        render: (rowData) =>
          rowData.first_party_id ? (
            <a href={`/person/edit/${rowData.first_party_id}`}>
              {rowData.first_party_fullname}
            </a>
          ) : (
            "مشخص نشده"
          ),
      },
      {
        title: "در وجه",
        field: "second_party_fullname",
        render: (rowData) =>
          rowData.second_party_id ? (
            <a href={`/person/edit/${rowData.second_party_id}`}>
              {rowData.second_party_fullname}
            </a>
          ) : (
            "مشخص نشده"
          ),
      },
      {
        title: "وضعیت",
        field: "status",
        sorting: false,
        render: (rowData) => {
          return rowData.status === "cashed" ? (
            <Box style={{ textAlign: "center" }}>
              <Box>
                <Alert severity={"success"}>پاس شده</Alert>
              </Box>
              <Box>{rowData.cashed_date_fa}</Box>
            </Box>
          ) : rowData.status === "bounced" ? (
            <Box style={{ textAlign: "center" }}>
              <Box>
                <Alert severity={"error"}>برگشت خورده</Alert>
              </Box>
              <Box>{rowData.bounced_date_fa}</Box>
            </Box>
          ) : rowData.status === "returned-settlement" ? (
            <Box style={{ textAlign: "center" }}>
              <Box>
                <Alert severity={"warning"}>عودتی - تسویه</Alert>
              </Box>
              <Box>{rowData.returned_date_fa}</Box>
            </Box>
          ) : rowData.status === "returned-unresolved" ? (
            <Box style={{ textAlign: "center" }}>
              <Box>
                <Alert severity={"warning"}>عودتی - بلاتکلیف</Alert>
              </Box>
              <Box>{rowData.returned_date_fa}</Box>
            </Box>
          ) : (
            <Box style={{ textAlign: "center" }}>-</Box>
          );
        },
        pdfRender: (rowData) => {
          if (rowData.status === "cashed") {
            return `${rowData.cashed_date_fa} - پاس شده`;
          } else if (rowData.status === "bounced") {
            return `${rowData.bounced_date_fa} - برگشت خورده`;
          } else if (rowData.status === "returned-settlement") {
            return `${rowData.returned_date_fa ? rowData.returned_date_fa : ""} - عودت تسویه`;
          } else if (rowData.status === "returned-unresolved") {
            return `${rowData.returned_date_fa ? rowData.returned_date_fa : ""} - عودت مفتوح`;
          } else {
            return "-";
          }
        },
      },
    ];
  };

  fetchAllCheques = (query) => {
    const userId = parseInt(this.props.userId);

    const baseVariables = {
      page: query.page + 1,
      limit: query.pageSize,
      search: query.search,
      orderBy: query.orderBy ? query.orderBy.field : null,
      orderDirection: query.orderDirection,
    };

    return Promise.all([
      client.query({
        query: QUERY_CHEQUES,
        variables: { ...baseVariables, giver_user_id: userId },
        fetchPolicy: "network-only",
      }),
      client.query({
        query: QUERY_CHEQUES,
        variables: { ...baseVariables, first_party_id: userId },
        fetchPolicy: "network-only",
      }),
    ]).then(([giverResult, ownerResult]) => {
      const giverCheques = structuredClone(giverResult.data.cheques.data);
      const ownerCheques = structuredClone(ownerResult.data.cheques.data);

      const mergedMap = new Map();
      [...giverCheques, ...ownerCheques].forEach((cheque) => {
        mergedMap.set(cheque.id, cheque);
      });

      const merged = Array.from(mergedMap.values());
      const totalCount = giverResult.data.cheques.total + ownerResult.data.cheques.total;

      return {
        data: merged,
        page: query.page,
        totalCount: totalCount,
      };
    });
  };

  fetchFilteredCheques = (query, status) => {
    const userId = parseInt(this.props.userId);

    return client
      .query({
        query: QUERY_CHEQUES,
        variables: {
          page: query.page + 1,
          limit: query.pageSize,
          user: userId,
          status: status,
          search: query.search,
          orderBy: query.orderBy ? query.orderBy.field : null,
          orderDirection: query.orderDirection,
        },
        fetchPolicy: "network-only",
      })
      .then((res) => {
        let data = structuredClone(res.data);
        return {
          data: data.cheques.data,
          page: query.page,
          totalCount: data.cheques.total,
        };
      });
  };

  fetchData = (query) => {
    const { activeTab } = this.state;

    if (activeTab === "all") {
      return this.fetchAllCheques(query);
    }

    const statusMap = {
      bounced: "bounced",
      cashed: "cashed",
      current: "current",
      returned: "returned-settlement",
    };

    return this.fetchFilteredCheques(query, statusMap[activeTab]);
  };

  render() {
    const { activeTab } = this.state;
    const tabs = [
      { key: "all", label: "همه چک ها" },
      { key: "bounced", label: "چک های برگشتی" },
      { key: "cashed", label: "چک های پاس شده" },
      { key: "current", label: "چک های جاری" },
      { key: "returned", label: "چک های عودتی" },
    ];

    return (
      <Card style={{ marginBottom: 16 }}>
        <CardContent>
          <Typography variant="h6" gutterBottom style={{ fontWeight: "bold", marginBottom: 16 }}>
            خلاصه چک ها
          </Typography>
          <Grid container spacing={1} style={{ marginBottom: 16 }}>
            {tabs.map((tab) => (
              <Grid item key={tab.key}>
                <Box
                  component="span"
                  onClick={() => this.setState({ activeTab: tab.key })}
                  style={{
                    padding: "8px 16px",
                    borderRadius: 4,
                    cursor: "pointer",
                    backgroundColor: activeTab === tab.key ? "#3f51b5" : "#e0e0e0",
                    color: activeTab === tab.key ? "#fff" : "#333",
                    fontWeight: activeTab === tab.key ? "bold" : "normal",
                    fontSize: 14,
                  }}
                >
                  {tab.label}
                </Box>
              </Grid>
            ))}
          </Grid>
          <MaterialTableRtl
            key={activeTab}
            columns={this.getColumns()}
            data={this.fetchData}
            editLink={"/cheque/edit/"}
            perPage={5}
            needExport={true}
            title={`${tabs.find((t) => t.key === activeTab)?.label || ""}`}
          />
        </CardContent>
      </Card>
    );
  }
}

export default ChequeSummaryTables;
